"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemLink = ItemLink;

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _MenuLink = require("./MenuLink");

var ItemLinkWrapper = /*#__PURE__*/(0, _theming.styled)("li", process.env.NODE_ENV === "production" ? {
  target: "evt4yg70"
} : {
  target: "evt4yg70",
  label: "ItemLinkWrapper"
})("list-style-type:none;&:last-of-type ", _MenuLink.MenuLink, "{margin-bottom:0;}");

function ItemLink(_ref) {
  var currentPath = _ref.currentPath,
      item = _ref.item;
  return /*#__PURE__*/_react["default"].createElement(ItemLinkWrapper, null, /*#__PURE__*/_react["default"].createElement(_MenuLink.MenuLink, {
    isActive: currentPath === item.path,
    href: item.path,
    LinkWrapper: item.LinkWrapper,
    tertiary: true
  }, item.title));
}